
import Hero from "./Components/Hero";
import Projects from "./Components/Projects"
import Footer from "./Components/Footer"

function App() {
  return (
    <div>
      <Hero/>
      <Projects/>
      <Footer/>
    </div>
  )
}

export default App;
